export const defaultGroupingRuleUrl = '.*';
